import { Info, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatTime } from "../lib/format";

export function DataMeta({ meta, className = "" }) {
  const { t, i18n } = useTranslation();
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground ${className}`}>
      {meta?.provider === "mock" && (
        <span className="inline-flex items-center rounded border border-primary/30 bg-primary/10 px-1.5 py-0.5 font-medium text-primary" data-testid="demo-data-badge">
          {t("x.demoData")}
        </span>
      )}
      <span className="inline-flex items-center gap-1.5">
        <Clock className="h-3.5 w-3.5" />
        {t("common.lastUpdated")}: <span className="num">{formatTime(meta?.lastUpdated, i18n.language)}</span>
      </span>
      <span className="inline-flex items-center gap-1.5">
        <Info className="h-3.5 w-3.5" />
        {t("common.notAdviceShort")}
      </span>
    </div>
  );
}

export function DisclaimerNote({ className = "" }) {
  const { t } = useTranslation();
  return (
    <p className={`rounded-md border border-border bg-muted/30 p-4 text-xs leading-relaxed text-muted-foreground ${className}`} data-testid="disclaimer-note">
      {t("common.notAdviceLong")}
    </p>
  );
}
